import React from 'react';
import styled from 'styled-components';

const RatioContent = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

interface Props {
  children: any;
  aspectRatio?: string;
}

const AspectRatio = ({ children, aspectRatio }: Props) => {
  if (!aspectRatio) {
    return children;
  }

  const [divider, value] = aspectRatio.split(':');

  const ratio = (parseInt(value, 10) / parseInt(divider, 10)) * 100;

  return (
    <div css={{ position: 'relative', paddingTop: `${ratio}%` }}>
      <RatioContent>{children}</RatioContent>
    </div>
  );
};

export default AspectRatio;
